import * as React from "react";
import { PlayerCardTheme } from "../../../../services/bedrock";
import { Dropdown, Icon, Menu } from "semantic-ui-react";
import { PlayerCardSettingsContext } from "../../Contexts";
import { useContext } from "react";

interface ThemePreviewProps {
  theme: PlayerCardTheme;
  currentUserIsOwner?: boolean;
  clickable?: boolean;
}

const ThemePreview: React.FC<ThemePreviewProps> = ({ theme, currentUserIsOwner = false }) => {
  const { Themes, PlayerCards, User } = useContext(PlayerCardSettingsContext);
  const isSelected = Themes.selectedTheme?.id === theme.id;

  const assignToPlayerCard = () => {
    Themes.setSelectedTheme(theme);
    if (PlayerCards.selectedPlayerCard && PlayerCards.selectedPlayerCard.id > 0) {
      PlayerCards.savePlayerCardTheme(PlayerCards.selectedPlayerCard.id, theme);
    }
  };

  const editTheme = () => {
    Themes.setSelectedTheme(theme);
    Themes.setInEditMode(true);
  };

  const duplicateTheme = () => {
    Themes.setSelectedTheme({ ...theme, id: -Date.now(), name: `${theme.name} (Copy)` });
    Themes.setInEditMode(true);
  };

  var isAssignedToPlayerCard = User.isPlayer && PlayerCards.selectedPlayerCard?.theme?.id === theme.id;
  const actions: { key: string; content: string; onClick: () => void }[] = [];
  if (User.hasWritePermission) {
    if (User.isPlayer && !isAssignedToPlayerCard) {
      actions.push({ key: "assign", content: "Assign to Player Card", onClick: assignToPlayerCard });
    }
    if (currentUserIsOwner) {
      actions.push({ key: "edit", content: "Edit", onClick: editTheme });
      actions.push({ key: "duplicate", content: "Duplicate", onClick: duplicateTheme });
      actions.push({ key: "delete", content: "Delete", onClick: () => Themes.deleteTheme(theme) });
    } else {
      actions.push({ key: "duplicate", content: "Duplicate", onClick: duplicateTheme });
    }
  }

  const classes = ["playerCardThemePreview"];
  if (isSelected) classes.push("selected");

  const selectTheme = () => {
    if (isSelected) {
      Themes.setInEditMode(currentUserIsOwner);
    } else {
      Themes.setSelectedTheme(theme);
    }
  };

  return (
    <div className={classes.join(" ")} onClick={selectTheme}>
      {actions.length > 0 && (
        <Menu className="actionsMenu">
          <Dropdown icon="ellipsis horizontal">
            <Dropdown.Menu>
              {actions.map(action => (
                <Dropdown.Item {...action} />
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Menu>
      )}

      {isAssignedToPlayerCard && <Icon className="assignedPlayerCardIcon" name="star" />}

      <div style={{ backgroundColor: theme.pageBackground, color: theme.pageForeground }} className="pagePreview">
        Page Text
        <div
          style={{ backgroundColor: theme.widgetBackground, color: theme.widgetForeground }}
          className="widgetPreview"
        >
          Widget Text
        </div>
      </div>
    </div>
  );
};
export default ThemePreview;
